<script>
import axios from 'axios'
import {closeAllSubNavs} from '../../header'
import ResourceConsumptionTime from './Resource/ConsumptionTime.vue'

const apiBaseUrl = '/api/v2'
const apiToken = '0CqllRTzofNymzrmrlsApOQSVSVBOGmW'

export default {
  data() {
    return {
      api: this.getResourcesApi(),
      section: -1,
      sections: [
        'resourcesWebinars',
        'resourcesThoughtLeadership',
        'resourcesFactSheets',
        'resourcesVideo',
        'resourcesBrochure',
        'resourcesBlog',
        'resourcesAdvisorResources'
      ],
      sectionsWithDateHiddenByDefault: [
        'resourcesAdvisorResources',
        'resourcesBrochure',
        'resourcesFactSheets',
        'resourcesVideo',
      ],
      product: 'all',
      searchString: '',
      resources: [],
      totalResources: 0,
      dataLoaded: false,
      loadingData: false,
      perPage: 12,
      page: 1
    }
  },
  props: {
    'id': {
      type: Number,
      default: 0
    },
  },
  components: {
    ResourceConsumptionTime
  },
  mounted() {
    this.setSectionBySlug()
    window.addEventListener("hashchange", this.hashChange, false)
  },
  computed: {
    loadMoreVisible() {
      return (this.resources.length < this.totalResources) && this.dataLoaded
    },
    loadMoreText() {
      return (this.loadingData) ? 'Loading...' : 'Load More'
    }
  },
  methods: {
    hashChange() {
      if (this.dataLoaded) {
        this.setSectionBySlug()
        closeAllSubNavs()
      }
    },
    setSectionBySlug() {
      let slug = location.hash.replace('#', '')
      if (slug.length) {
        let slugArray = slug.split('_');
        this.section = this.getSectionKeyFromSlug(slugArray[0]);
        this.product = (slugArray.length === 2) ? slugArray[1] : 'all';

        const section = document.querySelector('#resourceResults');
        section.scrollIntoView({ behavior: 'smooth' });
      }
      this.getResources(true)
    },
    getResources(reset = false) {
      this.loadingData = true;
      if (reset) {
        this.dataLoaded = false
        this.resources = []
        this.getResourcesCount()
      }

      this.api.post('', {query: this.getResourcesQuery()})
        .then((response) => {
          this.dataLoaded = true
          this.loadingData = false
          this.resources = this.resources.concat(response.data.data.entries)
        })
    },
    getResourcesCount() {
      this.api.post('', {query: this.getResourcesCountQuery()})
        .then((response) => {
          this.totalResources = response.data.data.entryCount
        })
    },
    getResourcesApi() {
      return axios.create({
        baseURL: apiBaseUrl,
        headers: {
          'Authorization': 'Bearer ' + apiToken,
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
    },
    setProduct() {
      this.page = 1
      this.searchString = ''
      this.setSectionHash()
      console.log(this.product)
    },
    setSection() {
      this.page = 1
      this.searchString = ''
      this.setSectionHash()
      this.getResources(true)
    },
    setSectionHash() {
      let slug = ''

      if (this.sections[this.section] !== undefined) {
        let section = this.sections[this.section].replace('resources', '')
        let words = section.split(/(?=[A-Z])/)
        slug = words.join('-').toLocaleLowerCase()
      }

      if (this.product !== 'all') {
        slug += '_' + this.product;
      }

      location.hash = slug

    },
    search() {
      this.page = 1
      this.section = -1
      this.product = 'all'
      location.hash = ''
      this.getResources(true)
    },
    loadMore() {
      this.page++
      this.getResources()
    },
    getType(resource) {
      return (resource.resTagOverride) ? resource.resTagOverride : resource.sectionHandle.match(/[A-Z][a-z]+|[0-9]+/g).join(" ")
    },
    getResourceUrl(resource) {
      let type = this.getResourceType(resource);
      return (type === 'link') ? resource.resLink : resource.url
    },
    getResourceTarget(resource) {
      let type = this.getResourceType(resource);
      return (type === 'entry') ? '_self' : '_blank'
    },
    getResourceType(resource) {
      let type = resource.__typename
      return (type.substr(type.length - 10) == 'link_Entry') ? 'link' : 'entry'
    },
    getOffset() {
      return this.perPage * (this.page - 1)
    },
    getResourcesCountQuery() {
      let selectedSections = this.getSelectedSections()
      let searchStatement = this.getSearchStatement()

      return `{
                    entryCount (section:[${selectedSections}], ${searchStatement})
                }`
    },
    getResourcesQuery() {

      let queryTypes = ''
      let selectedSections = this.getSelectedSections()

      for (let section of this.sections) {

        // section = section.charAt(0).toUpperCase() + section.slice(1)

        queryTypes += `...on ${section}_article_Entry {
                                      __typename
                                      typeHandle
                                      url
                                      title
                                      postDate @formatDateTime(format:"M d, Y")
                                      resHeadline
                                      resTagOverride
                                      resDateVisibility
                                      resConsumptionTime
                                      resConsumptionTimeMeasurement
                                      sectionHandle
                                      resAuthor {
                                        ...on authors_Entry {
                                          authorFirstName
                                          authorLastName
                                          authorPosition
                                        }
                                      }
                                      resThumbnail {
                                        thumbnail: url(transform: "resourceThumbnail")
                                      }
                                    }
                                    ...on ${section}_link_Entry {
                                      __typename
                                      typeHandle
                                      title
                                      resLink
                                      resHeadline
                                      resTagOverride
                                      resDateVisibility
                                      resConsumptionTime
                                      resConsumptionTimeMeasurement
                                      sectionHandle
                                      postDate @formatDateTime(format:"M d, Y")
                                      resThumbnail {
                                        thumbnail: url(transform: "resourceThumbnail")
                                      }
                                    }`
      }

      let searchStatement = this.getSearchStatement()
      let productStatement = (this.product !== 'all') ? `relatedToEntries: [{slug: "${this.product}"}]` : '';

      let resourceQuery = `{
                                      entries(section:[${selectedSections}],
                                                        ${productStatement}
                                                        limit: ${this.perPage}
                                                        offset: ${this.getOffset()}
                                                        orderBy: "postDate DESC"
                                                        ${searchStatement}) {
                                        ${queryTypes}
                                      }
                                    }`

      return resourceQuery
    },
    getSearchStatement() {
      let data = ''
      if (this.searchString.length) {
        data = `search:"resHeadline:${this.searchString}"`

      }
      return data
    },
    getSelectedSections() {
      let data = '"'
      if (this.section == -1) {
        data += this.sections.join('", "')
      } else {
        data = '"' + this.sections[this.section]
      }

      data += '"'
      return data
    },
    getSectionKeyFromSlug(slug) {
      let words = slug.split('-')
      let section = 'resources'

      for (let word of words) {
        section += word.charAt(0).toUpperCase() + word.slice(1)
      }

      return this.sections.indexOf(section)
    },
    showDate(resource) {
      if (this.sectionsWithDateHiddenByDefault.includes(resource.sectionHandle)) {
        return (resource.resDateVisibility) ? true : false
      } else {
        return (resource.resDateVisibility) ? false : true
      }
    }
  }
}
</script>
